<mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group">
  <mat-card class="ml-site-option-card mat-elevation-z0" *ngFor="let option of chooseOptions">
    <mat-radio-button
      class="ml-site-radio-button"
      color="primary"
      [value]="option"
      [checked]="chosenSiteOption?.id === option.id"
      (click)="onOptionClick(option)"
    >
      <div>{{ option.description }}</div>
      <div class="ml-option-subtitle" *ngIf="option.subtitle">{{ option.subtitle }}</div>
    </mat-radio-button>
    <ng-container *ngIf="option.expandable && option.expandable.value">
      <mat-form-field class="search">
        <input
          autocomplete="off"
          matInput
          placeholder="Search"
          (keyup)="applyFilter($event.target.value)"
        />
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>
      <mat-table class="sel-table" [dataSource]="sitesData">
        <ng-container matColumnDef="name">
          <td class="sel-table-col" mat-cell *matCellDef="let element">
            {{ element.sitesData.name }}
          </td>
        </ng-container>
        <tr
          mat-row
          class="sel-table-row sel-table-row-content"
          [class.element-selected]="row.sitesData?.id === selectedElement?.id"
          *matRowDef="let row; columns: displayedColumns"
          (click)="onRowClick(row.sitesData)"
        ></tr>
      </mat-table>
    </ng-container>
  </mat-card>
  <div [style.display]="!paginatorStatus ? 'block' : 'none'">
    <nrwl-paginator
      #paginator
      [totalResult]="(getSites() | async)?.length"
      [hidePageSizer]="true"
      (nextPage)="nextPage($event)"
    ></nrwl-paginator>
  </div>
</mat-radio-group>
